import React, { useState, useEffect, useRef } from "react";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import styles from "./Delivery1.module.css";
import { useAuth } from "../../components/context/Auth";
import Button from "../../components/updatedComponents/Dealers/Button";
import {
  RequestForDevice,
  TemplateNotFound,
} from "../../components/icons/Icon2";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import { AddIcon2 } from "../../components/icons/Icon";
import fetchData from "../../APIsControll/apiControll";
import DDropDown from "../../components/updatedComponents/Delivery/DDropDown";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import { DeleteTo, ViewTo } from "../../components/icons/Icon3";
import DeliveryCard from "../../components/updatedComponents/Delivery/DeliveryCard";
import { Editwarehouse } from "../../components/icons/Icon4";
import DeliveryPartnerTable from "../../components/updatedComponents/Delivery/DeliveryPartnerTable"; // ← new
import { ModalWrapper } from "../../exports";
import { socket, SocketConnected } from "../../Socket/socket";
import DeliveryDeviceModalContent from "../../components/updatedComponents/Delivery/DeliveryDeviceModalContent";
import { useNavigate } from "react-router-dom";

const Delivery1 = () => {
  const { managerId, mode, designation } = useAuth();
  const navigate = useNavigate();
  const { show } = useToast();
  const [loading, setLoading] = useState({
    stateLoading: false,
    cityLoading: false,
    getDeliveryLoading: false,
    getDeliveryPartnerLoading: false,
    locationsLoading: false,
  });

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const [allDelMethod, setAllDelMethod] = useState([]);
  const [products, setProducts] = useState([]);
  const [allDelPartners, setAllDelPartners] = useState([]);
  const [deliveryModal, setDeliveryModal] = useState(false);
  const [deliveryModalData, setDeliveryModalData] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(null);
  const [modelState, setModeleState] = useState(false);
  const [loadingIs, setloadingIs] = useState(false);
  const [modelContact, setModelContact] = useState(null);
  // =========================
  // GET STATES
  // =========================

  useEffect(() => {
    const getAllState = async () => {
      try {
        setLoading((prev) => ({ ...prev, stateLoading: true }));
        const res = await fetchData(`deliverymethod/getState`);
        if (res.status === "success") {
          const formattedStates = res.data.map((item) => ({
            label: item,
            value: item,
          }));
          setStates(formattedStates);
        }
      } catch (error) {
        show("Error fetching state", "error");
      } finally {
        setLoading((prev) => ({ ...prev, stateLoading: false }));
      }
    };
    getAllState();
  }, []);

  // =========================
  // GET CITIES
  // =========================

  useEffect(() => {
    if (!selectedState) {
      setCities([]);
      return;
    }
    const getCity = async () => {
      try {
        setLoading((prev) => ({ ...prev, cityLoading: true }));
        const payload = { stateName: selectedState.value };
        const res = await fetchData(`deliverymethod/getCity`, payload);
        if (res.status === "success") {
          const formattedCities = res.data.map((item) => ({
            label: item,
            value: item,
          }));
          setCities(formattedCities);
        }
      } catch (error) {
        show("Error fetching city", "error");
      } finally {
        setLoading((prev) => ({ ...prev, cityLoading: false }));
      }
    };
    getCity();
  }, [selectedState]);

  // =========================
  // GET DELIVERY METHOD
  // =========================

  useEffect(() => {
    const getDeliveryMethod = async () => {
      try {
        setLoading((prev) => ({ ...prev, getDeliveryLoading: true }));
        const res = await fetchData(`deliverymethod/getDeliveryMethod`);
        if (res.status === "success") {
          setAllDelMethod(res.data || []);
          setProducts(res.products || []);
        }
      } catch (error) {
        show("Error fetching delivery methods", "error");
      } finally {
        setLoading((prev) => ({ ...prev, getDeliveryLoading: false }));
      }
    };
    getDeliveryMethod();
  }, []);

  // =========================
  // FILTER DATA
  // =========================

  const filteredDeliveryMethods = allDelMethod.filter((item) => {
    const stateMatch = selectedState
      ? item.stateName === selectedState.value
      : true;
    const cityMatch = selectedCity
      ? item.cityName === selectedCity.value
      : true;
    return stateMatch && cityMatch;
  });

  // =========================
  // GET DELIVERY PARTNERS
  // =========================

  useEffect(() => {
    if (!selectedState || !selectedCity) {
      setAllDelPartners([]);
      return;
    }
    const getDeliveryPartner = async () => {
      try {
        setLoading((prev) => ({ ...prev, getDeliveryPartnerLoading: true }));
        const payload = {
          cityName: selectedCity.value,
          stateName: selectedState.value,
          courierId: "",
          partnerId: "",
        };
        const res = await fetchData(`deliverymethod/getPartner`, payload);
        if (res.status === "success") {
          setAllDelPartners(res.data || []);
        }
      } catch (error) {
        show("Error fetching delivery Partner", "error");
      } finally {
        setLoading((prev) => ({ ...prev, getDeliveryPartnerLoading: false }));
      }
    };
    getDeliveryPartner();
  }, [selectedState, selectedCity]);

  const togleModel = (contant) => {
    setModelContact(contant);
    setModeleState(true);
  };

  const getDeliveryPatner = async () => {
    try {
      const payload = { managerId: managerId };
      const res = await fetchData(`deliveryPartner/getalldevice`, payload);
      if (res.status === "success") {
        setDeliveryModalData(res.pendingDevices);
      }
      if (res.status === "failed") {
        setDeliveryModalData([]);
      }
    } catch (error) {
      //console.log(error);
    }
  };
  useEffect(() => {
    getDeliveryPatner();
  }, []);

  const handleOptionClick = async (option, data) => {
    if (option === "Active") {
      try {
        setloadingIs(true);
        const payload = {
          deviceId: data.deviceId,
          loginId: data.loginId,
          managerId: managerId,
        };
        const res = await fetchData(`deliveryPartner/acceptdevice`, payload);
        if (res.status === "success") {
          show(res.msg, "success");
          setModeleState(false);
          getDeliveryPatner();
        }
        if (res.status === "failed") {
          show(res.msg, "error");
        }
      } catch (error) {
        show("Error", "error");
      } finally {
        setloadingIs(false);
      }
    }
    if (option === "Disabled" || option === "Delete") {
      try {
        const payload = {
          loginId: data?.loginId,
          deviceId: data?.deviceId,
          action:
            option === "Disabled"
              ? "disable"
              : option === "Delete"
                ? "delete"
                : null,
        };
        const res = await fetchData(
          `deliveryPartner/deleteDisableDevice`,
          payload,
        );
        if (res.status === "success") {
          setModeleState(false);
          getDeliveryPatner();
          show(res.msg, "success");
        }
        if (res.status === "failed") {
          show(res.msg, "error");
        }
      } catch (error) {
        show("Error", "error");
      } finally {
      }
    }

    setDropdownVisible(null);
  };

  useEffect(() => {
    SocketConnected({
      socketUserId: `${managerId}`,
      role: designation,
      warehouseNames: JSON.parse(localStorage.getItem("warehouse")),
    });
    socket.on("newdevicereq", (newdevicereq) => {
      // console.log(newdevicereq);
      setDeliveryModalData((prev) => [...newdevicereq.pendingDevices, ...prev]);

      // setDeliveryModalData([...newdevicereq.pendingDevices, ...deliveryModalData])
    });
  }, []);

  // useEffect(() => {
  //   const getAllLocation = async () => {
  //     try {
  //       setLoading((prev) => ({ ...prev, locationsLoading: true }));
  //       const payload = {
  //         keyword: "",
  //         statename: "",
  //       };
  //       const res = await fetchData(`locations/locations`, payload);
  //       console.log("result", res);
  //     } catch (error) {
  //       show("Error fetching locations", "error");
  //     } finally {
  //       setLoading((prev) => ({ ...prev, locationsLoading: false }));
  //     }
  //   };
  //   getAllLocation();
  // }, []);

  return (
    <div className={`${styles.delivery} ${mode ? styles.dark : styles.light}`}>
      <ModalWrapper
        isOpen={deliveryModal}
        onClose={() => setDeliveryModal(false)}
      >
        <DeliveryDeviceModalContent
          mode={mode}
          data={deliveryModalData}
          loading={loadingIs}
          toggleModel={togleModel}
          setModeleState={setModeleState}
          handleOptionClick={handleOptionClick}
        />
      </ModalWrapper>

      <ModalWrapper isOpen={modelState} onClose={() => setModeleState(false)}>
        {modelContact}
      </ModalWrapper>

      {/* ── Top bar ── */}
      <div className={styles.delivery_top}>
        <TopTabBar text={"Delivery"} />

        <div>
          <Button
            buttonIcon={<RequestForDevice />}
            buttonText={"Request"}
            buttonBgColor={"#1B1D21"}
            buttonTextColor={"#FFFFFF"}
            buttonBorder={"none"}
            buttonClick={() => setDeliveryModal(true)}
            notify={deliveryModalData.length === 0 ? false : true}
            count={deliveryModalData.length}
          />
        </div>

        <div>
          <DDropDown
            label={"Select State"}
            listLabel={"state"}
            options={states}
            value={selectedState}
            onSelect={(option) => {
              setSelectedState(option);
              setSelectedCity(null);
              setCities([]);
            }}
            onReject={() => {
              setSelectedState(null);
              setSelectedCity(null);
              setCities([]);
            }}
          />
        </div>

        <div>
          <DDropDown
            label={"Select City"}
            listLabel={"city"}
            options={cities}
            value={selectedCity}
            onSelect={(option) => setSelectedCity(option)}
            onReject={() => setSelectedCity(null)}
          />
        </div>

        <div>
          <Button
            buttonText={"Add Delivery Method"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#FFFFFF"}
            buttonIcon={<AddIcon2 />}
            // buttonClick={() => show("Coming Soon...")}
            buttonClick={() =>
              navigate("/delivery/adddeliverymethod", {
                state: {
                  type: "Add Delivery Method",
                  productOptions: products,
                },
              })
            }
          />
        </div>
      </div>

      {/* ── Scrollable body ── */}
      <div className={styles.delmaindivscroll}>
        {/* ── Delivery Methods grid ── */}
        <div
          className={styles.del_data}
          style={
            mode
              ? { backgroundColor: "#232529" }
              : { backgroundColor: "#FFFFFF" }
          }
        >
          {loading.getDeliveryLoading ? (
            Array.from({ length: 6 }).map((_, index) => (
              <div key={index} style={{ width: "100%" }}>
                <Skeleton
                  thickness={6}
                  shape="circle"
                  width="50px"
                  height="50px"
                />
                <div style={{ width: "75%" }}>
                  <Skeleton lines={2} thickness={1} />
                </div>
                <Skeleton lines={1} thickness={3} />
              </div>
            ))
          ) : filteredDeliveryMethods.length === 0 ? (
            <div
              style={{
                gridColumn: "1 / -1",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
              }}
            >
              <NoDataFound
                icon={<TemplateNotFound />}
                to={"/templates/template"}
              />
              <p color={mode ? "#ffffff" : "#000000"}>No Data found</p>
            </div>
          ) : (
            filteredDeliveryMethods.map((item, i) => (
              <div className={styles.del_card} key={i}>
                <DeliveryCard
                  title={item.courierName}
                  subtitle={`${item.stateName}`}
                  subtitle1={`${item.cityName}`}
                  status={item.status}
                  imageUri=""
                  viewIcon={<ViewTo mode={mode} />}
                  editIcon={<Editwarehouse mode={mode} />}
                  deleteIcon={<DeleteTo mode={mode} />}
                  // onView={() => console.log("view")}
                  // onEdit={() => console.log("edit")}
                  // onDelete={() => console.log("delete")}

                  onView={() =>
                    navigate("/delivery/adddeliverymethod", {
                      state: {
                        type: "View Delivery Method",
                        data: item,
                        productOptions: products,
                      },
                    })
                  }
                  onEdit={() =>
                    navigate("/delivery/adddeliverymethod", {
                      state: {
                        type: "Update Delivery Method",
                        data: item,
                        productOptions: products,
                      },
                    })
                  }
                  onDelete={() => show("Deleted")}
                />
              </div>
            ))
          )}
        </div>

        {/* ── Delivery Partners TABLE ── */}
        <div className={styles.partnerSection}>
          <DeliveryPartnerTable
            allDelPartners={allDelPartners}
            loading={loading.getDeliveryPartnerLoading}
            mode={mode}
            onView={(item) => console.log("view", item)}
            onEdit={(item) => console.log("edit", item)}
            onDelete={(item) => console.log("delete", item)}
          />
        </div>
      </div>
    </div>
  );
};

export default Delivery1;
